// Throttle leading-edge : invoque fn immediatement, puis ignore les appels
// suivants pendant intervalMs. Pense a forcer un dernier appel (non throttle)
// au pointerup pour ne pas perdre la position finale.
//
// Utilise pour le scrub video (seekTo en continu pendant un drag) dans
// VideoPlayer (barre de progression) et TrimOverlay (poignees de decoupe).
export function makeThrottle(intervalMs) {
  let last = 0
  return (fn) => {
    const now = Date.now()
    if (now - last >= intervalMs) {
      last = now
      fn()
    }
  }
}
